/**
 * Collapses an exposed filter set.
 *
 * @param {string} viewID
 *   The ID of the view to collapse.
 */
function collapseFilter(viewID) {
  // Find the view in the DOM.
  const $view = $(`.${viewID}`);

  // Check if the view exists in the DOM based on the view ID in the
  // button.
  if ($view.length) {
    // Get the filter and content elements inside the view element.
    const $filter = $view.find('.filter-container');
    const $content = $view.find('.content-container');

    // Toggle the views filter open or closed`
    $filter.toggleClass('collapsed').find('.view-filters')
      .toggleClass('collapsed');
    $content.toggleClass('col-md-9 col-md-12');
  }
}

/**
 * Toggle's the closing and opening of view's exposed filters.
 */
Drupal.behaviors.collapseFilter = {
  attach: (context) => {
    once('filter-btn', '.btn-filter-toggle', context).forEach((button) => {
      // Fetch the filter toggle button.
      const $toggle = $(button);

      // Add or remove collapsed classes when the filter toggle is clicked.
      // These classes will handle the CSS that show/hides the filter.
      $toggle.on('click', (ev) => collapseFilter(ev.currentTarget.dataset.view));
    });

    // Find views that should have their filters collapsed on load.
    const collapseOnLoadSelector = '.l-collapsing-filter.collapse-filter';
    once('collapse-filter', collapseOnLoadSelector, context).forEach((view) => {
      // Fetch the view ID from the data attribute on the toggle button.
      const viewID = $(view).find('.btn-filter-toggle').attr('data-view');

      // Collapse the filter based on the view ID.
      collapseFilter(viewID);
    });

    once('collapse-fieldsets', '.filter-container .fieldgroup legend', context).forEach((fieldSet) => {
      // Get all individual filter options within the filter in order to give
      // the ability to collapse individual filters.
      const $fieldSets = $(fieldSet);
      // Quick helper function for closing individual filters.
      const collapse = (htmlElement) => {
        $(htmlElement).parent().toggleClass('collapsed');
      };
      // Allow the ability to show or hide individual filters.
      $fieldSets.on('click', (ev) => collapse(ev.currentTarget));
    });
  },
};
